var unitKeyMap = {
  '0': '公斤',
  '1': '棵',
  '2': '株',
  '3': '头',
  '4': '吨',
  '5': '尾',
  '6': '件',
  '7': '斤',
  '8': '只',
  '9': '个',
  '10': '克',
  '11': '袋',
  '12': '粒',
  '13': '包',
  '14': '盒',
  '15': '千粒',
  '16': '罐',
  '17': '平方米',
  '18': '盆',
  '19': '支',
  '20': '扎',
  '21': '亩',
  '22': '箱',
  '23': '瓶',
  '24': '千克',
  '25': '根',
  '26': '市斤',
  '27': '公分',
  '28': '捆',
  '29': '片',
  '30': '毫升',
  '31': '台',
  '32': '辆',
  '33': '立方米',
  '34': '对',
  '35': '条',
  '36': '桶',
  '37': '张',
  '38': '升',
  '39': '块',
  '40': '穗',
  '41': '米',
  '42': '寸',
  '43': '盘',
  '44': '段',
  '45': '车',
  '46': '把',
  '47': '架',
  '48': '壶',
  '49': '匹',
  '50': '套',
  '51': '卷',
  '52': '朵',
  '53': '筒',
  '54': '芽',
  '55': '羽',
  '56': '枚',
  '57': '脾',
  '58': '平方/月',
  '59': '平方/年',
  '60': '亩/月',
  '61': '亩/年',
  '63': '组'
}

module.exports = {
  toString: function(num) {
    if (!num) return
    num += ''
    return unitKeyMap[num] || ''
  },
  toFullString: function(num) {
    if (!num) return
    num += ''
    return unitKeyMap[num] ? '元/' + unitKeyMap[num] : ''
  }
}
